(function () {
  'use strict';

  (function () {
    new themegoal.helpers.Responsive();
    new TG_ProductCardColorSwatch();
    let windowWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      let newWidth = window.innerWidth;

      if (newWidth === windowWidth) {
        return;
      }

      let headerSection = document.getElementById('Header');
      let announcementBarSection = document.getElementById('AnnouncementBar');
      let pageHeader = document.getElementById('PageHeader');
      windowWidth = newWidth;
      document.documentElement.style.setProperty('--tg-window-height', window.innerHeight + 'px');

      if (headerSection) {
        document.documentElement.style.setProperty('--tg-header-height', headerSection.offsetHeight + 'px');
      }

      if (announcementBarSection) {
        document.documentElement.style.setProperty('--tg-announcement-bar-height', announcementBarSection.offsetHeight + 'px');
      }

      if (pageHeader) {
        document.documentElement.style.setProperty('--tg-page-header-height', pageHeader.offsetHeight + 'px');
      }
    });
    if (document.getElementById('SearchDrawer')) new TG_SearchDrawer();
  })();

})();
// ===============================
// VIERI – Anfertigungs-Mailto-Button (robust)
// ===============================

document.addEventListener('DOMContentLoaded', function () {

  const button = document.getElementById('VieriAnfertigungLink');
  if (!button) return;

  function checkAvailability() {
    const addToCartButton = document.querySelector('button[type="submit"][name="add"]');
    if (!addToCartButton) return;

    // Wenn Add-to-Cart disabled ist → Variante nicht verfügbar
    if (addToCartButton.hasAttribute('disabled')) {
      button.style.display = 'flex';
    } else {
      button.style.display = 'none';
    }
  }

  // Initial check
  checkAvailability();

  // Beobachte DOM-Änderungen (Variant-Wechsel ohne Events)
  const observer = new MutationObserver(function () {
    checkAvailability();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });

});
